import { useEffect, useState, useRef } from "react";

export default function OurClients() {
  const [isFakeDesktop, setIsFakeDesktop] = useState(false);
  const [dynamicLeft, setDynamicLeft] = useState("50%");
  const containerRef = useRef(null);

  useEffect(() => {
    const check = () => {
      if (typeof window !== "undefined") {
        const fake =
          window.screen.width < 900 && window.innerWidth >= 900;
        setIsFakeDesktop(fake);
      }
    };

    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  /* 🔥 Calculate true laptop geometry proportion */
  useEffect(() => {
    if (!isFakeDesktop || !containerRef.current) {
      setDynamicLeft("50%");
      return;
    }

    const containerWidth = containerRef.current.offsetWidth;

    /*
      On laptop:
      background-position is 46% center
      So visual center alignment ≈ 46% of container
    */

    const proportionalLeft = 46; // Laptop reference alignment

    setDynamicLeft(`${proportionalLeft}%`);
  }, [isFakeDesktop]);

  return (
    <section className="clients-wrapper">
      <div className="clients-container">

        <div className="clients-heading">
          <h2
            style={{
              fontFamily: "'PP Neue Montreal', sans-serif",
              fontWeight: 400,
              fontSize: "clamp(36px, 4.5vw, 60px)",
              lineHeight: "1.18",
              letterSpacing: "0.05em",
              color: "#0b0b0b",
            }}
          >
            <span style={{ display: "block" }}>Working With Those</span>
            <span style={{ display: "block" }}>That Value Quality</span>
          </h2>
        </div>

        <div
  ref={containerRef}
  className={`clients-frame ${isFakeDesktop ? "force-desktop-height allow-overflow" : ""}`}
>


          <div
  className="frame-left"
  style={
    isFakeDesktop
      ? {
          marginLeft: "calc(1%)",
          transform: "none",
        }
      : {}
  }
>

            <p className="panel-title">
              Brands & Communities We Craft For :
            </p>

            <ul className="panel-list">
              <li>Film & Entertainment</li>
              <li>Corporates</li>
              <li>Sports</li>
              <li>Educational Institutes</li>
              <li>Small Businesses</li>
            </ul>
          </div>

          <div className="frame-right">
            <img
  src="/client_sk.png"
  alt="actor"
  className="actor-img"
  style={
    isFakeDesktop
      ? {
          left: "30%",
          transform: "none",
          bottom: "-10px",
          width: "650px"
        }
      : {}
  }
/>

          </div>

        </div>
      </div>

      <style>{`
        .clients-wrapper {
          width: 100%;
          background: #ffff;
          padding-left: 4vw;
          padding-right: 4vw;
          padding-bottom: 60px;
        }

        .clients-container {
          max-width: 1600px;
          margin: 0 auto;
        }

        .clients-heading {
          max-width: 720px;
          margin-bottom: 56px;
        }

        .clients-frame {
          position: relative;
          display: grid;
          grid-template-columns: 1.1fr 1fr;
          align-items: center;
          padding: 44px 56px 0;
          border-radius: 6px;
          min-height: 340px;
          overflow: visible;
        }

        .force-desktop-height {
          min-height: 520px;
        }

        .allow-overflow {
  overflow: visible !important;
}


        .clients-frame::before {
          content: "";
          position: absolute;
          inset: 0;
          background-image: url("/client_frame.png");
          background-size: cover;
          background-position: 46% center;
          background-repeat: no-repeat;
          border-radius: 6px;
          z-index: 0;
        }

        .frame-left {
          position: relative;
          z-index: 1;
          background: #2a2a2a;
          padding: 28px 30px;
          border-radius: 6px;
          max-width: 520px;
          transform: translateY(-21px);
        }

        .panel-title {
          font-size: 15px;
          color: #ffffff;
          margin-bottom: 18px;
        }

        .panel-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .panel-list li {
          border: 1px solid rgba(255,255,255,0.35);
          border-radius: 999px;
          padding: 8px 16px;
          font-size: 14px;
          color: #ffffff;
          width: fit-content;
        }

        .frame-right {
          position: relative;
          z-index: 1;
          display: flex;
          justify-content: center;
          align-items: flex-end;
        }

        .actor-img {
          position: absolute;
          bottom: -96px;
          left: 50%;
          transform: translateX(-50%) scale(1.32);
          width: min(480px, 85%);
          z-index: 2;
          pointer-events: none;
          filter:
            drop-shadow(0 45px 70px rgba(0,0,0,0.45))
            drop-shadow(0 0 18px rgba(255,255,255,0.12));
        }

        @media (max-width: 1024px) {
          .clients-frame {
            grid-template-columns: 1fr;
            gap: 40px;
            padding: 40px 40px 40;
            overflow: hidden;
          }

          .frame-left {
            margin: 0 auto;
            transform: none;
          }

          .frame-right {
            min-height: 320px;
          }

          .actor-img {
            bottom: 0;
          }
            
        }

        @media (max-width: 480px) {
          .clients-frame {
            padding: 32px 20px 40px;
            gap: 28px;
            min-height: 520px;
            overflow: hidden;
          }

          .actor-img {
            width: 88%;
            bottom: 0;
          }
        }

      `}</style>
    </section>
  );
}
